// extracted by mini-css-extract-plugin
module.exports = {"container":"EditCustomDomainListDashboard_container__16hx-"};